import { RootState } from 'store/types';

export const selectCalendar = (state: RootState) => state.timesheet.engineeringCalendar;

export const selectCalendarList = (state: RootState) => selectCalendar(state).calendar.list;

export const selectLoading = (state: RootState) => selectCalendar(state).calendar.loading;

export const selectDrag = (state: RootState) => selectCalendar(state).drag;

export const selectCurrent = (state: RootState) => selectCalendar(state).drag.current;

export const selectDraggable = (state: RootState) => selectCalendar(state).drag.draggable;

export const selectDragData = (state: RootState) => selectCalendar(state).drag.data;

export const selectDistribution = (state: RootState) => selectCalendar(state).distribution.list;

export const selectDistributionCount = (state: RootState) =>
  selectCalendar(state).distribution.count;

export const selectDistLoading = (state: RootState) => selectCalendar(state).distribution.loading;

export const selectCurrentDate = (state: RootState) => selectCalendar(state).date.currentDate;

export const currentPaginationStart = (state: RootState) =>
  selectCalendar(state).paginationStart.start;

export const selectIsDragForwarding = (state: RootState) =>
  selectCalendar(state).drag.isDragForwarding;

export const selectForwardingStepTime = (state: RootState) =>
  selectCalendar(state).drag.forwardingStepTime;

export const selectCalendarParams = ({ timesheet: { engineeringCalendar } }: RootState) => {
  return {
    start_date: engineeringCalendar.paginationStart.start,
  };
};
